/** The room mounted (true) or removed (false) the interpreter's Tools panel. */
export const SET_INTERPRETER_TOOLS_MOUNTED = 'SET_INTERPRETER_TOOLS_MOUNTED';
/** The Tools panel opened (true) or minimized back to its key (false). */
export const SET_INTERPRETER_TOOLS_OPEN = 'SET_INTERPRETER_TOOLS_OPEN';
/** A transfer from this room started or stopped waiting for acceptance. */
export const SET_INTERPRETER_TOOLS_TRANSFER_PENDING = 'SET_INTERPRETER_TOOLS_TRANSFER_PENDING';
